import { LICENSE_MODULES, ROLES } from '../../../../../constants';
import ONE from './ONE';
import REPORTS from './REPORTS';
import VIEW from './VIEW';

import dashboardIcon from '../../assets/icons/grey/dashboard_grey.svg';
import dashboardActiveIcon from '../../assets/icons/blue/dashboard_blue.svg';
import employeesIcon from '../../assets/icons/grey/Employees_grey.svg';
import employeesActiveIcon from '../../assets/icons/blue/Employees_blue.svg';
import administrationIcon from '../../assets/icons/grey/Administration_grey.svg';
import administrationActiveIcon from '../../assets/icons/blue/Administration_blue.svg';
import teamActiveIcon from '../../assets/icons/blue/team_blue.svg';
import teamIcon from '../../assets/icons/grey/team_grey.svg';
import partsActiveIcon from '../../assets/icons/blue/parts_blue.svg';
import partsIcon from '../../assets/icons/grey/parts_grey.svg';
import machinesActiveIcon from '../../assets/icons/blue/machines_blue.svg';
import machinesIcon from '../../assets/icons/grey/machines_grey.svg';
import articlesActiveIcon from '../../assets/icons/blue/articles_blue.svg';
import articlesIcon from '../../assets/icons/grey/articles_grey.svg';
import administrationBlockActiveIcon from '../../assets/icons/blue/administration_block.svg';
import administrationBlockIcon from '../../assets/icons/grey/administration_block.svg';
import recycleIcon from '../../assets/icons/grey/recycle_grey.svg';
import recycleActiveIcon from '../../assets/icons/blue/recycle_blue.svg';
import listIcon from '../../assets/icons/grey/list_grey.svg';
import listActiveIcon from '../../assets/icons/blue/list_blue.svg';
import apiIcon from '../../assets/icons/grey/api_grey.svg';
import apiActiveIcon from '../../assets/icons/blue/api_blue.svg';
import qrIcon from '../../assets/icons/grey/qr_grey.svg';
import qrActiveIcon from '../../assets/icons/blue/qr_blue.svg';
import dynamicDataIcon from '../../assets/icons/grey/suppliers_grey.svg';
import dynamicDataActiveIcon from '../../assets/icons/blue/suppliers_blue.svg';
import usersIcon from '../../assets/icons/grey/users_grey_icon.svg';
import usersActiveIcon from '../../assets/icons/blue/users_blue_icon.svg';

export default {
  commonTop: [
    {
      name: '',
      items: [
        {
          name: 'dashboard',
          titleKey: 'dashboard',
          icon: dashboardIcon,
          activeIcon: dashboardActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/dashboard',
          roles: '*',
        },
      ],
    },
  ],
  [LICENSE_MODULES.IS_REPORTS_PART]: REPORTS,
  [LICENSE_MODULES.ONE]: ONE,
  [LICENSE_MODULES.VIEW]: VIEW,
  commonBottom: [
    {
      name: 'Reference Data',
      projects: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      items: [
        // {
        //   name: 'Customers',
        //   titleKey: 'Customers',
        //   icon: employeesIcon,
        //   activeIcon: employeesActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/one/customers',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE],
        // },
        // {
        //   name: 'Contacts',
        //   titleKey: 'Contacts',
        //   icon: teamIcon,
        //   activeIcon: teamActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/one/contacts',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE],
        // },
        // {
        //   name: 'Article',
        //   titleKey: 'Article',
        //   icon: articlesIcon,
        //   activeIcon: articlesActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/one/article',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE],
        // },
        // {
        //   name: 'Machines / Equipment',
        //   titleKey: 'Machines / Equipment',
        //   icon: machinesIcon,
        //   activeIcon: machinesActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/one/machines',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE],
        // },
        // {
        //   name: 'Parts',
        //   titleKey: 'Parts',
        //   icon: partsIcon,
        //   activeIcon: partsActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/one/parts',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE],
        // },
        // {
        //   name: 'Stickers',
        //   titleKey: 'Stickers',
        //   icon: listIcon,
        //   activeIcon: listActiveIcon,
        //   isCollapsed: false,
        //   isActive: false,
        //   route: '/stickers',
        //   roles: '*',
        //   projects: [LICENSE_MODULES.ONE, LICENSE_MODULES.IS_REPORTS_PART],
        // },
        {
          name: 'dynamic-data',
          titleKey: 'Dynamic data',
          icon: dynamicDataIcon,
          activeIcon: dynamicDataActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/dynamic-data',
          roles: '*',
          projects: [LICENSE_MODULES.ONE, LICENSE_MODULES.IS_REPORTS_PART],
        },
        {
          name: 'Lists',
          titleKey: 'Lists',
          icon: listIcon,
          activeIcon: listActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/lists',
          roles: '*',
          projects: [LICENSE_MODULES.ONE, LICENSE_MODULES.IS_REPORTS_PART],
        },
        {
          name: 'Content',
          titleKey: 'Content',
          icon: listIcon,
          activeIcon: listActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/content',
          roles: '*',
          projects: [LICENSE_MODULES.ONE, LICENSE_MODULES.IS_REPORTS_PART],
        },
        {
          name: 'Company',
          titleKey: 'Company',
          icon: teamIcon,
          activeIcon: teamActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/company',
          roles: '*',
          projects: [LICENSE_MODULES.ONE, LICENSE_MODULES.IS_REPORTS_PART],
        },
      ],
    },
    {
      name: 'Administration',
      icon: administrationBlockIcon,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      items: [
        {
          name: 'api-management',
          titleKey: 'Api Management',
          route: '/api-management',
          icon: apiIcon,
          activeIcon: apiActiveIcon,
          isActive: false,
          roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
        },
        {
          name: 'qr-management',
          titleKey: 'QR Code Management',
          route: '/qr-management',
          icon: qrIcon,
          activeIcon: qrActiveIcon,
          isActive: false,
          roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
        },
        {
          name: 'teams',
          titleKey: 'teams',
          icon: teamIcon,
          activeIcon: teamActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/teams',
          roles: '*',
        },
        {
          name: 'users',
          titleKey: 'users',
          route: '/users',
          icon: usersIcon,
          activeIcon: usersActiveIcon,
          isActive: false,
          roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
        },
        {
          name: 'recycle-bin',
          titleKey: 'Recycle Bin',
          route: '/recycle-bin',
          icon: recycleIcon,
          activeIcon: recycleActiveIcon,
          isActive: false,
          roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
        },
        {
          name: 'settings',
          titleKey: 'settings',
          icon: administrationIcon,
          activeIcon: administrationActiveIcon,
          isCollapsed: false,
          isActive: false,
          route: '/system',
          roles: [ROLES.SUPERADMIN],
        },
      ],
    },
  ],
};
